import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Route } from 'react-router-dom'

import { Dashboard } from './pages/Dashboard';
import { createStore, combineReducers, applyMiddleware } from "redux";
import ReduxThunk from 'redux-thunk'
import { Provider } from "react-redux";
import { SingletonHooksContainer } from 'react-singleton-hook'

import SetupReducer from './redux/reducers/SetupReducer';
import LocationReducer from './redux/reducers/LocationReducer';
import CensusReducer from './redux/reducers/CensusReducer';
import ToasterReducer from './redux/reducers/ToasterReducer';
import SpinnerReducer from './redux/reducers/SpinnerReducer';
import SettingReducer from './redux/reducers/SettingReducer';
import AuthReducer from './redux/reducers/AuthReducer'
import HierarchyReducer from './redux/reducers/HierarchyReducer';
import AttendanceReducer from './redux/reducers/AttendanceReducer';
import WaitlistReducer from './redux/reducers/WaitlistReducer';

import Toaster from './utilities/ProToaster';
import PrimeReact from 'primereact/api';
import ProgressSpinner from './utilities/ProProgressSpinner';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import DialogReducer from './redux/reducers/DialogReducer';
import FormReducer from './redux/reducers/FormReducer';



export const RTLContext = React.createContext();
const rootReducer = combineReducers({
    setup: SetupReducer,
    location: LocationReducer,
    toaster: ToasterReducer,
    spinner: SpinnerReducer,
    setting: SettingReducer,
    census: CensusReducer,
    auth: AuthReducer,
    hierarchy:HierarchyReducer,
    attendance:AttendanceReducer,
    waitlist:WaitlistReducer,
    dialog: DialogReducer,
    form:FormReducer,
});
const store = createStore(rootReducer, applyMiddleware(ReduxThunk));

const App = () => {

    const [menuMode, setMenuMode] = useState('static');
    const [desktopMenuActive, setDesktopMenuActive] = useState(true);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [activeTopbarItem, setActiveTopbarItem] = useState(null);
    const [colorMode, setColorMode] = useState('light');   
    const [menuActive, setMenuActive] = useState(false);  
    const [inlineMenuActive, setInlineMenuActive] = useState({});
    const [newThemeLoaded, setNewThemeLoaded] = useState(false);
    const [searchActive, setSearchActive] = useState(false)
    let currentInlineMenuKey = useRef(null);



    PrimeReact.ripple = true;

    let searchClick;
    let topbarItemClick;
    let menuClick;
    let inlineMenuClick;

    useEffect(() => {
        if (menuMode === 'overlay') {
            hideOverlayMenu()
        }
        if (menuMode === 'static') {
            setDesktopMenuActive(true)
        }
    }, [menuMode])


    const onDocumentClick = (event) => {
        if (!searchClick && event.target.localName !== 'input') {
            setSearchActive(false);
        }

        if (!topbarItemClick) {
            setActiveTopbarItem(null);
        }

        if (!menuClick && (menuMode === 'overlay' || !isDesktop())) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false)
            }
            hideOverlayMenu();
        }

        if (inlineMenuActive[currentInlineMenuKey.current] && !inlineMenuClick) {
            let menuKeys = { ...inlineMenuActive };
            menuKeys[currentInlineMenuKey.current] = false;
            setInlineMenuActive(menuKeys);
        }

        if (!menuClick && (isSlim() || isHorizontal())) {
            setMenuActive(false);
        }

        searchClick = false;
        topbarItemClick = false;
        inlineMenuClick = false;
        menuClick = false;
    }

    const hideOverlayMenu = () => {
        setMobileMenuActive(false)
        setDesktopMenuActive(false)
    }

    const isDesktop = () => {
        return window.innerWidth > 1024;
    }

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    }

    const isSlim = () => {
        return menuMode === 'slim';
    }

    const isIE = () => {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent)
    }




    return (
        <Provider store={store}>
            <>
                <SingletonHooksContainer />
                <div  onClick={onDocumentClick}>
                    <div className="layout-main">
                        <div className="layout-content">
                            <Route path="/" exact render={() => <Dashboard colorMode={colorMode} isNewThemeLoaded={newThemeLoaded} onNewThemeChange={e => setNewThemeLoaded(e)} />} />
                        </div>                      
                        <ProgressSpinner />
                    </div>
                    <Toaster />
                    {mobileMenuActive && <div className="layout-mask modal-in"></div>}
                </div>
            </>
        </Provider>
    );

}

export default App;
